export default __webpack_public_path__ + "5437bcfb3e08154b05f9660c0031bfa5.svg";